import { render } from "./FlowButton.vue?vue&type=template&id=33f88a70&scoped=true&ts=true"
import script from "./FlowButton.vue?vue&type=script&lang=ts"
export * from "./FlowButton.vue?vue&type=script&lang=ts"

import "./FlowButton.vue?vue&type=style&index=0&id=33f88a70&scoped=true&lang=css"

import exportComponent from "/home/cretzler/source/Contributr-v2/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f88a70"]])

export default __exports__